var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImagePlaceholder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 158,
    height: 159,
    viewBox: "0 0 158 159",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M153.7 137.505L109.2 93.0047C115.4 83.6047 119 72.4047 119 60.3047C119 27.5047 92.3 0.804688 59.5 0.804688C26.7 0.804688 0 27.5047 0 60.3047C0 93.1047 26.7 119.805 59.5 119.805C71.4 119.805 82.5 116.305 91.8 110.205L136.4 154.805C138.8 157.205 141.9 158.405 145.1 158.405C148.2 158.405 151.4 157.205 153.8 154.805C156.1 152.505 157.4 149.405 157.4 146.105C157.4 142.805 156 139.805 153.7 137.505ZM15 60.3047C15 35.8047 35 15.8047 59.5 15.8047C84.1 15.8047 104 35.8047 104 60.3047C104 84.8047 84.1 104.805 59.5 104.805C35 104.805 15 84.9047 15 60.3047ZM88.9 60.3047C88.9 64.4047 85.5 67.8047 81.4 67.8047H67V82.2047C67 86.3047 63.6 89.7047 59.5 89.7047C55.4 89.7047 52 86.4047 52 82.2047V67.8047H37.6C33.5 67.8047 30.1 64.4047 30.1 60.3047C30.1 56.2047 33.5 52.8047 37.6 52.8047H52V38.4047C52 34.3047 55.4 30.9047 59.5 30.9047C63.6 30.9047 67 34.3047 67 38.4047V52.8047H81.4C85.6 52.8047 88.9 56.2047 88.9 60.3047Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImagePlaceholder);
export default __webpack_public_path__ + "static/media/image-placeholder.4578a581.svg";
export { ForwardRef as ReactComponent };